import { useEffect, PropsWithChildren } from 'react'
import { useModal } from '~/hooks/useModal'

type Props = PropsWithChildren<{
  isOpen: boolean
  onClose: () => void
}>

export const HalfModal: React.FC<Props> = ({ isOpen, onClose, children }) => {
  const [Modal, openModal, closeModal, isModalOpen] = useModal(300)
  useEffect(() => {
    // if (isOpen) openModal()
    // else closeModal()
  }, [isOpen, openModal, closeModal])

  return (
    <Modal
      className="absolute bottom-0 w-full"
      overlayClassName={`bg-black/25 transition-opacity ease-linear duration-200 absolute ${
        isModalOpen ? 'opacity-100' : 'opacity-0'
      }`}
      wrapperClassName="xl:w-[600px] xl:mx-auto"
      onOverlayClick={onClose}
    >
      <div
        className={`overflow-hidden rounded-t-2xl transition-transform duration-200 ease-linear ${
          isModalOpen ? 'translate-y-0' : 'translate-y-[300px]'
        }`}
      >
        {children}
      </div>
    </Modal>
  )
}
